import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var updateNotSendReadReceipt = mutatorAction('updateNotSendReadReceipt', function (notSendReadReceipt) {
    var store = mobileDeviceFullStore();
    store.notSendReadReceipt = notSendReadReceipt;
});
//# sourceMappingURL=updateNotSendReadReceipt.js.map